module.exports = __webpack_public_path__ + "img/lxwo.cd6449d2.png";